<template lang="pug">
.vip-container
  NewTransferTab(
    v-if="tabList && tabList.length > 1"
    :show="shouldShowTab"
    :activeTabKey="activeTabKey"
    :isApp="isApp"
    :tabs="tabList"
    @change="handleTabChange"
    :tabCode="tabCode"
  )
  div(
    v-for="(item, index) in vipPageList"
    :key="index"
  )
    KeepAlive
      component(
        v-if="isActiveTab(item)"
        :key="index"
        :is="item.openFlag ? 'opened' : 'unopen'"
          :openedData="item.openFlag ? item.moduleData.userProperty : undefined"
          :downPropVersion="!!(item.openFlag && item.moduleData && item.moduleData.userProperty && item.moduleData.userProperty.downPropVersion)"
          :vipData="getProcessedModuleData(item.moduleData)"
          @refresh="handleRefresh"
          @closeOpen="handleCloseOpen"
        )
</template>

<script>
import opened from './new-member/opened.vue';
import unopen from './new-member/unopen.vue';
import NewTransferTab from './new-transfer-tab.vue';

export default {
  name: 'VipContainer',
  components: {
    opened,
    unopen,
    NewTransferTab,
  },
  props: {
    vipPageList: {
      type: Array,
      default: () => [],
    },
    tabCode: {
      type: String,
      default: '',
    },
    isApp: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      activeTabKey: '',
    };
  },
  computed: {
    tabList() {
      return this.generateTabList();
    },
    shouldShowTab() {
      return this.tabList && this.tabList.length > 1 && this.tabCode !== 'ladder' && !!this.activeTabKey;
    },
  },
  watch: {
    vipPageList: {
      immediate: true,
      handler() {
        this.initActiveTab();
      },
    },
  },
  methods: {
    /**
     * 从 vipPageList 生成 tabList
     * 与 newVersion.vue 中的逻辑保持一致
     */
    generateTabList() {
      if (!Array.isArray(this.vipPageList) || this.vipPageList.length === 0) {
        return [];
      }

      return this.vipPageList
        .filter((item) => item && (item.tabName || item.moduleCode))
        .map((item) => ({
          tabKey: this.getTabKey(item),
          title: item.tabName || '',
          subTitle: item.tabSubTitle || '',
          logoImg: item.logoImg || '',
        }));
    },
    /**
     * 获取 tabKey，优先使用 tabCode，然后使用 moduleCode，最后使用索引
     */
    getTabKey(item) {
      // 优先使用 tabCode
      if (item.tabCode) {
        return item.tabCode;
      }

      // 其次使用 moduleCode
      if (item.moduleCode) {
        // 处理类似 'ride_one_cent（1分骑）（假设是已开通）' 这样的 moduleCode
        const code = item.moduleCode.split('（')[0].trim();
        // 清理下划线和其他特殊字符，转换为合适的 tabKey 格式
        return code.replace(/_/g, '').toLowerCase() || `tab_${this.vipPageList.indexOf(item)}`;
      }

      // 最后使用索引作为 fallback
      return `tab_${this.vipPageList.indexOf(item)}`;
    },
    /**
     * 初始化激活的 tab
     */
    initActiveTab() {
      if (!this.vipPageList || this.vipPageList.length === 0) {
        return;
      }

      // 查找 anchor 为 true 的 item
      const anchorItem = this.vipPageList.find((item) => item.anchor === true);
      if (anchorItem) {
        this.activeTabKey = this.getTabKey(anchorItem);
      } else if (this.vipPageList.length > 0) {
        // 如果没有 anchor，使用第一个
        this.activeTabKey = this.getTabKey(this.vipPageList[0]);
      }
      // 初始化时告知外层所选会员版本
      this.$emit('tabChange', { tabKey: this.activeTabKey });
    },
    /**
     * 判断当前 item 是否是激活的 tab
     */
    isActiveTab(item) {
      return this.getTabKey(item) === this.activeTabKey;
    },
    /**
     * 处理 tab 切换
     */
    handleTabChange({ tabKey }) {
      this.activeTabKey = tabKey;
      this.$emit('tabChange', { tabKey });
    },
    handleRefresh() {
      this.$emit('refresh');
    },
    handleCloseOpen(...args) {
      this.$emit('closeOpen', ...args);
    },
    /**
     * 处理 moduleData，如果是 newH5Version，将 goodsList 处理成 [goodsList]
     */
    getProcessedModuleData(moduleData) {
      if (!moduleData) {
        return moduleData;
      }
      // 如果是 newH5Version，需要将 goodsList 包装成数组
      const processedData = { ...moduleData };
      if (processedData.goodsList) {
        // 将 goodsList 包装成数组，与 unopen.vue 中的逻辑保持一致
        processedData.goodsList = [processedData.goodsList];
      }
      return processedData;
    },
  },
};
</script>

<style lang="less" scoped>
.vip-container {
  width: 100%;
}
</style>
